<template>
  <right-banner-template :title="title">
    <div class="customer-content">
      <div class="customer-grid">
        <div v-for="(customer,index) in getCustomers" :key="index" class="box">
          <router-link v-if="customer.link" :to="{ name: 'customer-detail', params: { url: customer.link }}">
            <!-- <img @contextmenu.prevent :src="require(`../../assets/customer/${customer.img}`) "> -->
             <img @contextmenu.prevent :src="imageSrc(customer.path)">
          </router-link>
          <a href="#" v-else>
             <img @contextmenu.prevent :src="imageSrc(customer.path)">
          </a>
        </div>
      </div>
    </div>
  </right-banner-template>
</template>

<script>
export default {
  props: ['title'],
  data () {
    return {
      cacheBuster: Date.now()
    }
  },
  computed: {
    getCustomers () {
      return this.$store.getters['media/getCustomers']
    }
  },
  methods: {
    imageSrc (src) {
      return `${src}?t=${this.cacheBuster}`
    }
  }
}
</script>

<style scoped>
  .customer-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 35px;
    margin-bottom: 50px;
    padding: 10px 20px;
  }

  .box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 120px;
  }

  .box a {
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  }

  .box img {
    max-width: 100%;
    max-height: 100%;
  }

  @media (max-width: 720px) {
  .customer-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 485px) {
  .customer-grid {
    grid-template-columns: 1fr;
  }
}

</style>
